import { ButtonOwnProps } from '@mui/material';

import scssVariables from 'styles/sass-variables.module.scss';

export const buttonOverrides = {
  root: ({ ownerState }: { ownerState: ButtonOwnProps }) => ({
    padding: '12px 16px',
    boxShadow: 'none',
    borderRadius: '8px',
    lineHeight: '16px',
    fontWeight: 700,
    transition: 'all .3s ease-in-out',

    ...(ownerState.variant === 'contained' && {
      color: scssVariables.white,
      fill: scssVariables.white,
      border: '1px solid transparent',
    }),
    ...(ownerState.variant === 'contained' &&
      ownerState.color === 'primary' && {
        backgroundColor: scssVariables.primary_purple_default,
        '&:hover': {
          backgroundColor: scssVariables.primary_purple_600,
        },
        '&:active': {
          backgroundColor: scssVariables.primary_purple_700,
        },
      }),
    ...(ownerState.variant === 'contained' &&
      ownerState.color === 'secondary' && {
        backgroundColor: scssVariables.brand_orange_default,
        '&:hover': {
          backgroundColor: scssVariables.brand_orange_600,
        },
        '&:active': {
          backgroundColor: scssVariables.brand_orange_700,
        },
      }),
    ...(ownerState.variant === 'contained' &&
      ownerState.color === 'gradient' && {
        background: scssVariables.aiGradient,
      }),
    ...(ownerState.variant === 'outlined' &&
      ownerState.color === 'primary' && {
        backgroundColor: scssVariables.primary_purple_100,
        border: `1px solid ${scssVariables.primary_purple_300}`,
        color: scssVariables.primary_purple_default,
        fill: scssVariables.primary_purple_default,
        '&:hover': {
          backgroundColor: scssVariables.primary_purple_200,
          border: `1px solid ${scssVariables.primary_purple_300}`,
        },
        '&:active': {
          border: `1px solid ${scssVariables.primary_purple_300}`,
          backgroundColor: scssVariables.primary_purple_300,
        },
      }),
    ...(ownerState.variant === 'outlined' &&
      ownerState.color === 'secondary' && {
        backgroundColor: scssVariables.brand_orange_100,
        border: `1px solid ${scssVariables.brand_orange_300}`,
        color: scssVariables.brand_orange_default,
        fill: scssVariables.brand_orange_default,
        '&:hover': {
          backgroundColor: scssVariables.brand_orange_200,
          border: `1px solid ${scssVariables.brand_orange_300}`,
        },
        '&:active': {
          border: `1px solid ${scssVariables.brand_orange_300}`,
          backgroundColor: scssVariables.brand_orange_300,
        },
      }),
    ...(ownerState.variant === 'outlined' &&
      ownerState.color === 'info' && {
        border: `1px solid ${scssVariables.greys_border}`,
        color: scssVariables.greys_text,
        fill: scssVariables.greys_text,
        '&:hover': {
          border: `1px solid ${scssVariables.greys_border}`,
          color: scssVariables.greys_black,
          fill: scssVariables.greys_black,
        },
        '&:active': {
          border: `1px solid ${scssVariables.greys_border}`,
          backgroundColor: scssVariables.greys_background,
          color: scssVariables.greys_black,
          fill: scssVariables.greys_black,
        },
      }),
    ...(ownerState.variant === 'outlined' &&
      ownerState.color === 'gradient' && {
        border: `1px solid ${scssVariables.aiBorder}`,
        background: scssVariables.aiGradient,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }),
    ...(ownerState.variant === 'text' &&
      ownerState.color === 'primary' && {
        color: scssVariables.primary_purple_default,
        fill: scssVariables.primary_purple_default,
        '&:hover': {
          backgroundColor: 'transparent',
          color: scssVariables.primary_purple_600,
          fill: scssVariables.primary_purple_600,
        },
        '&:active': {
          backgroundColor: 'transparent',
          color: scssVariables.primary_purple_700,
          fill: scssVariables.primary_purple_700,
        },
      }),
    ...(ownerState.variant === 'text' &&
      ownerState.color === 'secondary' && {
        color: scssVariables.brand_orange_default,
        fill: scssVariables.brand_orange_default,
        '&:hover': {
          backgroundColor: 'transparent',
          color: scssVariables.brand_orange_600,
          fill: scssVariables.brand_orange_600,
        },
        '&:active': {
          backgroundColor: 'transparent',
          color: scssVariables.brand_orange_700,
          fill: scssVariables.brand_orange_700,
        },
      }),
    ...(ownerState.variant === 'text' &&
      ownerState.color === 'info' && {
        color: scssVariables.greys_text,
        fill: scssVariables.greys_text,
        '&:hover': {
          backgroundColor: 'transparent',
          color: scssVariables.greys_black,
          fill: scssVariables.greys_black,
        },
      }),
    ...(ownerState.variant === 'text' &&
      ownerState.color === 'gradient' && {
        background: scssVariables.aiGradient,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',

        '&.Mui-disabled': {
          display: 'none',
        },
      }),

    ...(ownerState.size === 'large' && {
      fontSize: '14px',
      padding: '12px 18px',
      height: '40px',
      minWidth: '80px',
    }),
    ...(ownerState.size === 'small' && {
      fontSize: '12px',
      padding: '8px 12px',
      height: '32px',
      minWidth: '65px',
    }),

    ...(ownerState.variant === 'text' && {
      fontWeight: 600,
    }),

    svg: {
      width: '18px',
      height: '18px',
    },
    '&.Mui-disabled': {
      pointerEvents: 'auto',
      backgroundColor: scssVariables.greys_background,
      color: scssVariables.greys_disabled_text,
      border: `1px solid ${scssVariables.greys_border}`,
      boxSizing: 'border-box',
      '&:hover': {
        cursor: 'not-allowed',
      },
      ...(ownerState.variant === 'text' && {
        '&.Mui-disabled': {
          backgroundColor: 'transparent',
          border: '1px solid transparent',
          color: scssVariables.greys_disabled_text,

          fontWeight: 600,
          '&:hover': {
            border: '1px solid transparent',
            backgroundColor: 'transparent',
            color: scssVariables.greys_disabled_text,
          },
        },
      }),

      // GRADIENT BUTTONS - DISABLED
      ...(ownerState.variant === 'contained' &&
        ownerState.color === 'gradient' && {
          '&.Mui-disabled': {
            background: scssVariables.greys_disabled_text,
            backgroundColor: scssVariables.greys_background,
          },
        }),
      ...(ownerState.variant === 'outlined' &&
        ownerState.color === 'gradient' && {
          '&.Mui-disabled': {
            background: scssVariables.greys_disabled_text,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          },
        }),
      ...(ownerState.variant === 'text' &&
        ownerState.color === 'gradient' && {
          '&.Mui-disabled': {
            background: scssVariables.greys_disabled_text,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          },
        }),
    },
  }),
};
